export default "/_next/static/chunks/fonts/FontAwesome5_Brands-9e138496e8f1719c6ebf0abe50563635.ttf";